const GenerateReport = () => import("./main");

export default [
  {
    name: "generate-report",
    path: "/generate-report",
    component: GenerateReport
  }
];
